import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../../utils/withRouter';
import Loader from '../../../../utils/Loader'
// import { clearSessionStorage } from '../../../utils/constants'
import Header from '../../../../common_components/Header';
// import { emailValidator } from '../../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from '../../../../common_components/Footerwithdr';
import HeaderWithLogo from '../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../common_components/admin_module_drawer';
import { fill_action } from '../../../../actions/fillCombo_action'
// import ReceiptList from '../registration_receipt/ReceiptList';
import { Link } from "react-router-dom";
import { getAdminApplicationSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action"
import { getAdminDashboardData_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action"
import { data } from 'jquery';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip"
class ApplicationSummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            applicationSummaryList: [],
            pendingPaymentCount: '',
        }
        this.record = this.record.bind(this)
        this.getDashboardData = this.getDashboardData.bind(this)
        this.navToPaymentList = this.navToPaymentList.bind(this)
        this.getApplicationSummaryList = this.getApplicationSummaryList.bind(this)
        this.onCountClick = this.onCountClick.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.getDashboardData()
        this.getApplicationSummaryList()
    }

    // Get DashBoard Data
    getDashboardData() {
        this.setState({ isLoading: true })
        this.props.getAdminDashboardData_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Admin Dashboard Data ------->", data.data)
                    this.setState({
                        isLoading: false,
                        pendingPaymentCount: data.data[0]['Count_Of_Payment']
                    })
                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Get suummary list
    getApplicationSummaryList() {
        this.setState({ isLoading: true })
        this.props.getAdminApplicationSummaryList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Admin Data ------->", data.data)
                    // data.data.length > 0 && data.data.map((dat) => (
                    //     dat.Total = dat.Applied + dat.Agent + dat.Waiting + dat.Incomplete
                    // ))
                    // data.data.sort((a, b) =>
                    //     a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                    // );
                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedArea = 0
                    var temptotalIncompleteExhCount = 0
                    var temptotalIncompleteArea = 0
                    var temptotalBalanceArea = 0
                    var obj = {}

                    for (var i = 0; i < data.data.length; i++) {
                        temptotalSalable = temptotalSalable + data.data[i].SaleableArea
                        temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[i].AppliedExibitorCount
                        temptotalAppliedArea = temptotalAppliedArea + data.data[i].AppliedArea
                        temptotalIncompleteExhCount = temptotalIncompleteExhCount + data.data[i].IncompleteExibitorCount
                        temptotalIncompleteArea = temptotalIncompleteArea + data.data[i].IncompleteArea
                        temptotalBalanceArea = temptotalBalanceArea + data.data[i].BalanceArea
                    }

                    obj.SaleableArea = temptotalSalable
                    obj.AppliedExibitorCount = temptotalAppliedExhCount
                    obj.AppliedArea = temptotalAppliedArea
                    obj.IncompleteExibitorCount = temptotalIncompleteExhCount
                    obj.IncompleteArea = temptotalIncompleteArea
                    obj.BalanceArea = temptotalBalanceArea
                    obj.ChapterName = 'TOTAL'
                    if (data.data.length > 0 && data.data[data.data.length - 1].ChapterName != 'TOTAL') {
                        data.data.push(obj)
                    }
                    this.setState({
                        isLoading: false,
                        applicationSummaryList: data.data,
                        // pendingPaymentCount: data.data[0]['Count_Of_Payment']
                    })
                    console.log("Data ------->", this.state.applicationSummaryList)

                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    navToPaymentList() {
        this.props.navigate('/paymentlist')
    }

    onCountClick(chapterName, status) {
        console.log("Keyword------------>", `${chapterName.trim()}/${status}`)
        this.props.navigate('/exhibitorlist', { state: { fromDashBoard: true, keyword: `${chapterName.trim()}/${status}`, tab: "Application Summary" } })
    }


    record(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Primary Segment</th>
                        <th className="text-center">Salable Area(sqm)</th>
                        <th className="text-center" colspan="2">Applied</th>
                        <th className="text-center" colspan="2">Incomplete</th>
                        <th className="text-center">Balance Area (sqm)</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">Exhibitor Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Exhibitor Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.ChapterName}</strong>
                                        ) : (
                                            <>
                                                {data.ChapterName}

                                                {data.HallNames && (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id={`tooltip-${i}`}>
                                                                {data.HallNames}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i
                                                            className="bi bi-info-circle ms-1"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </OverlayTrigger>
                                                )}
                                            </>
                                        )}
                                    </td>
                                    <td className={data.SaleableArea < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "SaleableArea")}
                                    >{i == list.length - 1 ? <strong>{data.SaleableArea}</strong> : data.SaleableArea}</td>
                                    <td className={data.AppliedExibitorCount < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitorCount}</strong> : data.AppliedExibitorCount}</td>
                                    <td className={data.AppliedArea < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedArea}</strong> : data.AppliedArea}</td>
                                    <td className={data.IncompleteExibitorCount < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "IncompleteExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.IncompleteExibitorCount}</strong> : data.IncompleteExibitorCount}</td>
                                    <td className={data.IncompleteArea < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "IncompleteArea")}
                                    >{i == list.length - 1 ? <strong>{data.IncompleteArea}</strong> : data.IncompleteArea}</td>
                                    <td className={data.BalanceArea < 0 ? "text-center text-danger" : "text-center"}  style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "BalanceArea")}
                                    >{i == list.length - 1 ? <strong>{data.BalanceArea}</strong> : data.BalanceArea}</td>
                                    {/* <td className="text-center" style={{ cursor: "pointer" }}
                                        onClick={(e) => this.onCountClick(data.ChapterName, "Alloted")}
                                    >{i == list.length - 1 ? <strong>{data.Alloted}</strong> : data.Alloted}</td> */}
                                </tr>
                            ))}
                            {/* {list[list.length - 1].ChapterName != 'TOTAL' && <tr key={Math.random()}>
                                <td className="text-center"><strong>TOTAL</strong></td>
                                <td className="text-center"><strong>{this.state.totalApplied}</strong></td>
                                <td className="text-center"><strong>{this.state.totalAgent}</strong></td>
                                <td className="text-center"><strong>{this.state.totalWaiting}</strong></td>
                                <td className="text-center"><strong>{this.state.totalIncomplete}</strong></td>
                                <td className="text-center"><strong>{this.state.totalTotal}</strong></td>
                                <td className="text-center"><strong>{this.state.totalAlloted}</strong></td>
                            </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    render() {
        const { isLoading, pendingPaymentCount, applicationSummaryList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />
                    <div className='admin-top-space'>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.record(applicationSummaryList)}
                            </div>
                        </div>

                    </div>

                </>


            </>
        );
    }
}

export default withRouter(connect(null, { getAdminDashboardData_action, getAdminApplicationSummaryList_action })(ApplicationSummary));
